// extracted by mini-css-extract-plugin
export default {"mainWrapper":"input-date-picker_mainWrapper__n6Upb","dropdownWrapper":"input-date-picker_dropdownWrapper__lxxTR"};